import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';
const parent = 'PUBLIC_'

export function anonymousSettingLoad(filters){
  const url = `/anonymous/${API_VERSION_ONE}/anonymous_calendar_setting`;
  const method = 'GET'

  return {
    type: `${parent}ANONYMOUS_CALENDAR_SETTING_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function publicAnonymousRecurringSchedulesLoad(filters){
  const url = `/anonymous/${API_VERSION_ONE}/anonymous_calendar_recurring_schedules`;
  const method = 'GET'

  return {
    type: `ANONYMOUS_CALENDAR_RECURRING_SCHEDULES_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function publicAnonymousPerDaySchedulesLoad(filters) {
  const url = `/anonymous/${API_VERSION_ONE}/anonymous_calendar_per_day_schedules`;
  const method = 'GET'

  return {
    type: `ANONYMOUS_CALENDAR_PER_DAY_SCHEDULES_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}
